import './card-successverhalen.scss';

export default () => {};
